import { Injectable } from '@angular/core';
import { WrapperHttpService } from '../../../../services/wrapper-http-service';
import { Observable } from 'rxjs';
import { API_URL } from '../../../../../services/config';
import { DockEndpoint } from '../constants/dock-endpoint';
import { DockBrief, DockListURIParams } from '../models';
import { getQueryStringFromObject } from '../../../../../common/utils';
import { HubEndpoint } from '../../hub/constants/hub-endpoint';
import { CompartmentEndpoint } from '../../compartment/constants/compartment-endpoint';

@Injectable({
  providedIn: 'root',
})
export class DockListService {
  constructor(private http: WrapperHttpService) {}

  getDockList({ compartmentId, hubId, searchCriteria }: DockListURIParams): Observable<DockBrief[]> {
    const url =
      `${API_URL}${HubEndpoint.Base}/${hubId}${CompartmentEndpoint.Base}/${compartmentId}${DockEndpoint.Base}?` +
      getQueryStringFromObject(searchCriteria);
    return this.http.withLoading().get<DockBrief[]>(url);
  }

  enableDock({
    hubId,
    compartmentId,
    dockId,
    enable,
  }: {
    hubId: number;
    compartmentId: number;
    dockId: number;
    enable: boolean;
  }): Observable<boolean> {
    const url = `${API_URL}${HubEndpoint.Base}/${hubId}${CompartmentEndpoint.Base}/${compartmentId}${DockEndpoint.Base}/${dockId}${DockEndpoint.Enable}`;

    return this.http.withLoading().post<boolean>(url, { enable });
  }
}
